import ApiService from '@/common/api.service'
import CsrfService from '@/common/csrf.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import {
  LOGIN_URL,
  DEMO_URL,
  LOGOUT_URL,
  REGISTER_URL,
  REGISTER_CONFIRM_URL,
  FORGOT_PASSWORD_URL,
  FORGOT_PASSWORD_CONFIRM_URL,
  VERIFY_PHONE_NUMBER_URL,
  RESEND_SMS_URL
} from '@/constants/ApiConstants'
import { ENTER_EMAIL_URL } from '../../constants/ApiConstants'

const state = {
  errors: null,
  user: window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : null,
  isAuthenticated: !!window.localStorage.getItem('user'),
  currency: window.localStorage.getItem('currency') ? JSON.parse(window.localStorage.getItem('currency')) : null,
  dateFormat: window.localStorage.getItem('dateFormat') ? window.localStorage.getItem('dateFormat') : '',
  isEmailConfirmed: window.localStorage.getItem('emailConfirmed') ? JSON.parse(window.localStorage.getItem('emailConfirmed')) : false,
  hasCoparent: window.localStorage.getItem('hasCoparent') ? JSON.parse(window.localStorage.getItem('hasCoparent')) : false,
  hasChildren: window.localStorage.getItem('hasChildren') ? JSON.parse(window.localStorage.getItem('hasChildren')) : false,
  hasRecordKeepingCoparents: window.localStorage.getItem('hasRecordKeepingCoparents') ? JSON.parse(window.localStorage.getItem('hasRecordKeepingCoparents')) : false,
  canSendFunds: window.localStorage.getItem('canSendFunds') ? JSON.parse(window.localStorage.getItem('canSendFunds')) : null,
  coparentGuid: window.localStorage.getItem('coparentGuid') ? window.localStorage.getItem('coparentGuid') : null,
  isSubscribed: window.localStorage.getItem('subscriptionActive') ? JSON.parse(window.localStorage.getItem('subscriptionActive')) : false,
  countryCode: window.localStorage.getItem('countryCode') ? window.localStorage.getItem('countryCode') : 'US',
  firstLogin: window.localStorage.getItem('firstLogin') ? JSON.parse(window.localStorage.getItem('firstLogin')) : true,
  paymentPreferenceCompleted: window.localStorage.getItem('paymentPreferenceCompleted') ? JSON.parse(window.localStorage.getItem('paymentPreferenceCompleted')) : false,
  parentingSchedulePreferenceCompleted: window.localStorage.getItem('parentingSchedulePreferenceCompleted') ? JSON.parse(window.localStorage.getItem('parentingSchedulePreferenceCompleted')) : false,
  transactionsSuspended: window.localStorage.getItem('transactionsSuspended') && window.localStorage.getItem('transactionsSuspended') !== 'undefined' ? JSON.parse(window.localStorage.getItem('transactionsSuspended')) : false,
}

const getters = {
  user: (state) => state.user,
  isAuthenticated: (state) => state.isAuthenticated,
  currency: (state) => state.currency,
  dateFormat: (state) => state.dateFormat,
  isEmailConfirmed: (state) => state.isEmailConfirmed,
  hasCoparent: (state) => state.hasCoparent,
  hasChildren: (state) => state.hasChildren,
  hasRecordKeepingCoparents: (state) => state.hasRecordKeepingCoparents,
  canSendFunds: (state) => state.canSendFunds,
  isSubscribed: (state) => state.isSubscribed,
  countryCode: (state) => state.countryCode,
  firstLogin: (state) => state.firstLogin,
  coparentGuid: (state) => state.coparentGuid,
  paymentPreferenceCompleted: (state) => state.paymentPreferenceCompleted,
  parentingSchedulePreferenceCompleted: (state) => state.parentingSchedulePreferenceCompleted,
  transactionsSuspended: (state) => state.transactionsSuspended,
}

const actions = {
  [action.LOGIN] ({ commit}, credentials) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(LOGIN_URL, credentials)
        .then((res) => {
          let authData = {
            auth: res.headers['fp-csrf'],
            date: res.data.data.dateFormat,
            email: res.data.data.emailConfirmed,
            hasCoparent: res.data.data.hasCoparents,
            hasChildren: res.data.data.hasChildren,
            hasRecordKeepingCoparents: res.data.data.hasRecordKeepingCoparents,
            funds: res.data.data.canSendFunds,
            subscription: res.data.data.subscriptionActive,
            country: res.data.data.countryCode,
            coparentGuid: res.data.data.coparentGuid,
            paymentPreferenceCompleted: res.data.data.paymentPreferenceCompleted,
            parentingSchedulePreferenceCompleted: res.data.data.parentingSchedulePreferenceCompleted,
            user: {
              firstname: res.data.data.firstName,
              lastname: res.data.data.lastName
            },
            currency: res.data.data.currency,
            transactionsSuspended: res.data.data.transactionsSuspend
          }

          commit(mutation.SET_AUTH, authData)
          return resolve(res)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.LOGOUT] ({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(LOGOUT_URL)
        .then((data) => {
          commit(mutation.PURGE_AUTH);
          commit(mutation.SET_IS_BANK_ACCOUNT_SKIPPED, false);
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.DEMO] ({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(DEMO_URL, credentials)
        .then((res) => {
          let authData = {
            auth: res.headers['fp-csrf'],
            date: res.data.data.dateFormat,
            email: res.data.data.emailConfirmed,
            hasCoparent: res.data.data.hasCoparents,
            hasChildren: res.data.data.hasChildren,
            hasRecordKeepingCoparents: res.data.data.hasRecordKeepingCoparents,
            funds: res.data.data.canSendFunds,
            subscription: res.data.data.subscriptionActive,
            country: res.data.data.countryCode,
            coparentGuid: res.data.data.coparentGuid,
            paymentPreferenceCompleted: res.data.data.paymentPreferenceCompleted,
            parentingSchedulePreferenceCompleted: res.data.data.parentingSchedulePreferenceCompleted,
            user: {
              firstname: res.data.data.firstName,
              lastname: res.data.data.lastName
            },
            currency: res.data.data.currency
          }
          
          commit(mutation.SET_AUTH, authData)
          return resolve(res)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.REGISTER] (_, registerData) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(REGISTER_URL.replace(':g-recaptcha-response', registerData.recaptchaToken), registerData)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.ENTER_EMAIL] (_, emailData) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(ENTER_EMAIL_URL,emailData)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.REGISTER_CONFIRM] (_, registerData) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(REGISTER_CONFIRM_URL.replace(':g-recaptcha-response', registerData.recaptchaToken), registerData)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.FORGOT_PASSWORD] (_, registerData) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(FORGOT_PASSWORD_URL, registerData)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.FORGOT_PASSWORD_CONFIRM] (_, registerData) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(FORGOT_PASSWORD_CONFIRM_URL, registerData)
        .then((data) => {
            return resolve(data)
        })
        .catch((error) => {
            return reject(error.response)
        })
    })
  },
  [action.VERIFY_PHONE_NUMBER] (_, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(VERIFY_PHONE_NUMBER_URL, data)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.RESEND_SMS] (_, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(RESEND_SMS_URL, data)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return reject(error.response)
        })
    })
  },
  [action.SET_PAYMENT_PREFERENCE_COMPLETED] ({ commit }, data) {
    commit(mutation.SET_PAYMENT_PREFERENCE_COMPLETED, data)
  },
  [action.SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED] ({ commit }, data) {
    commit(mutation.SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED, data)
  },
}

const mutations = {
  [mutation.SET_ERROR] (state, error) {
    state.errors = error
  },
  [mutation.SET_AUTH] (state, authData) {
    state.isAuthenticated = true
    state.errors = {}
    state.dateFormat = authData.date
    window.localStorage.setItem("dateFormat", state.dateFormat)
    // User Email Confirmation
    state.isEmailConfirmed = authData.email
    window.localStorage.setItem("emailConfirmed", state.isEmailConfirmed)
    // Read the Boolean value if the User has co-parent
    state.hasCoparent = authData.hasCoparent
    window.localStorage.setItem("hasCoparent", state.hasCoparent)
    // Read the Boolean value if the User has children
    state.hasChildren = authData.hasChildren
    window.localStorage.setItem("hasChildren", state.hasChildren)
    // Read the Boolean value if the User has recod keeping co-parent
    state.hasRecordKeepingCoparents = authData.hasRecordKeepingCoparents
    window.localStorage.setItem("hasRecordKeepingCoparents", state.hasRecordKeepingCoparents)
    // Read the Boolean value if the User has valid Bank account
    state.canSendFunds = authData.funds
    window.localStorage.setItem("canSendFunds", state.canSendFunds)
    // Read the Boolean if the User has subscription payment method
    state.isSubscribed = authData.subscription
    window.localStorage.setItem("subscriptionActive", state.isSubscribed)
    // Read the String value if the User is "US" or "GB"
    state.countryCode = authData.country
    window.localStorage.setItem("countryCode", state.countryCode)

    state.coparentGuid = authData.coparentGuid;
    window.localStorage.setItem('coparentGuid', state.coparentGuid);
  
    state.paymentPreferenceCompleted = authData.paymentPreferenceCompleted;
    window.localStorage.setItem('paymentPreferenceCompleted', state.paymentPreferenceCompleted);
  
    state.parentingSchedulePreferenceCompleted = authData.parentingSchedulePreferenceCompleted;
    window.localStorage.setItem('parentingSchedulePreferenceCompleted', state.parentingSchedulePreferenceCompleted);
  
    state.user = authData.user;
    window.localStorage.setItem('user', JSON.stringify(state.user));
  
    state.currency = authData.currency;
    window.localStorage.setItem('currency', JSON.stringify(state.currency));
  
    state.transactionsSuspended = authData.transactionsSuspended;
    window.localStorage.setItem('transactionsSuspended', JSON.stringify(state.transactionsSuspended));

    CsrfService.saveToken(authData.auth)
    ApiService.setHeader()
  },
  [mutation.PURGE_AUTH] () {
    CsrfService.destroyToken()
    ApiService.removeTokenAuthHeader()
    localStorage.clear()
  },
  [mutation.SET_USER] (state, user) {
    state.user = user
    window.localStorage.setItem('user', JSON.stringify(state.user))
  },
  [mutation.SET_HAS_COPARENT] (state, hasCoparent) {
    state.hasCoparent = hasCoparent
    window.localStorage.setItem('hasCoparent', JSON.stringify(state.hasCoparent))
  },
  [mutation.SET_HAS_CHILDREN] (state, hasChildren) {
    state.hasChildren = hasChildren
    window.localStorage.setItem('hasChildren', JSON.stringify(state.hasChildren))
  },
  [mutation.SET_HAS_RECORD_KEEPING_COPARENTS] (state, hasRecordKeepingCoparents) {
    state.hasRecordKeepingCoparents = hasRecordKeepingCoparents
    window.localStorage.setItem('hasRecordKeepingCoparents', JSON.stringify(state.hasRecordKeepingCoparents))
  },
  [mutation.SET_FIRST_LOGIN] (state, firstLogin) {
    state.firstLogin = firstLogin
    window.localStorage.setItem('firstLogin', JSON.stringify(state.firstLogin))
  },
  [mutation.SET_CAN_SEND_FUNDS] (state, canSendFunds) {
    state.canSendFunds = canSendFunds
    window.localStorage.setItem('canSendFunds', JSON.stringify(state.canSendFunds))
  },
  [mutation.SET_IS_SUBSCRIBED] (state, isSubscribed) {
    state.isSubscribed = isSubscribed
    window.localStorage.setItem('isSubscribed', JSON.stringify(state.isSubscribed))
  },
  [mutation.SET_PAYMENT_PREFERENCE_COMPLETED] (state, paymentPreferenceCompleted) {
    state.paymentPreferenceCompleted = paymentPreferenceCompleted
    window.localStorage.setItem('paymentPreferenceCompleted', JSON.stringify(state.paymentPreferenceCompleted))
  },
  [mutation.SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED] (state, parentingSchedulePreferenceCompleted) {
    state.parentingSchedulePreferenceCompleted = parentingSchedulePreferenceCompleted
    window.localStorage.setItem('parentingSchedulePreferenceCompleted', JSON.stringify(state.parentingSchedulePreferenceCompleted))
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}
